import { all } from 'redux-saga/effects'
import watchEventsGetAllRequest from './watchEventsGetAllRequest'
import watchEventUpdateRequest from './watchEventUpdateRequest'
import watchEventDeleteRequest from './watchEventDeleteRequest'
import watchEventSendMailRequest from './watchEventSendMailRequest'

export default function* eventSaga() {
    yield all([
        watchEventsGetAllRequest(),
        watchEventUpdateRequest(),
        watchEventDeleteRequest(),
        watchEventSendMailRequest()
    ])
}